import React from 'react';
import { Search, X, Filter, Calendar, User, BookOpen, CheckCircle, XCircle } from 'lucide-react';

const PonctualiteSearchBar = ({ 
  searchTerm, 
  setSearchTerm, 
  searchFilters, 
  setSearchFilters,
  activeTab,
  classes,
  modules,
  showAdvancedFilters,
  setShowAdvancedFilters
}) => {
  const handleClearSearch = () => {
    setSearchTerm('');
    setSearchFilters({
      dateDebut: '',
      dateFin: '',
      classe: '',
      module: '',
      statut: '',
      volumeMin: '',
      volumeMax: ''
    });
  };

  return (
    <div className="space-y-3">
      {/* Barre de recherche principale */}
      <div className="flex items-center space-x-3">
        <div className="relative flex-1">
          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
            <Search className="h-4 w-4 text-gray-400" />
          </div>
          <input
            type="text"
            placeholder={`Rechercher...`}
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="block w-full pl-9 pr-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-[#202654] focus:border-transparent placeholder-gray-500 bg-white transition-all duration-200 text-sm"
          />
        </div>
        
        {searchTerm && (
          <button
            onClick={handleClearSearch}
            className="p-2 text-gray-400 hover:text-gray-600 transition-colors"
          >
            <X className="h-4 w-4" />
          </button>
        )}
        
        <button
          onClick={() => setShowAdvancedFilters(!showAdvancedFilters)}
          className={`p-2 rounded-md transition-all duration-200 ${
            showAdvancedFilters 
              ? 'bg-[#202654] text-white' 
              : 'text-gray-400 hover:text-gray-600 hover:bg-gray-100'
          }`}
        >
          <Filter className="h-4 w-4" />
        </button>
      </div>

      {/* Filtres avancés */}
      {showAdvancedFilters && (
        <div className="bg-gray-50 rounded-md p-3 border border-gray-200 animate-in slide-in-from-top duration-200">
          <div className="grid grid-cols-2 md:grid-cols-5 gap-3">
            {/* Filtre par classe */}
            <select
              value={searchFilters.classe}
              onChange={(e) => setSearchFilters({...searchFilters, classe: e.target.value})}
              className="px-2 py-1.5 border border-gray-300 rounded-md focus:ring-2 focus:ring-[#202654] focus:border-transparent text-sm"
            >
              <option value="">Toutes classes</option>
              {classes.map(classe => (
                <option key={classe.id} value={classe.id}>
                  {classe.libelle}
                </option>
              ))}
            </select>

            {/* Filtre par module */}
            <select
              value={searchFilters.module}
              onChange={(e) => setSearchFilters({...searchFilters, module: e.target.value})}
              className="px-2 py-1.5 border border-gray-300 rounded-md focus:ring-2 focus:ring-[#202654] focus:border-transparent text-sm"
            >
              <option value="">Tous modules</option>
              {modules.map(module => (
                <option key={module.id} value={module.id}>
                  {module.libelle}
                </option>
              ))}
            </select>

            {/* Filtre par statut */}
            <select
              value={searchFilters.statut}
              onChange={(e) => setSearchFilters({...searchFilters, statut: e.target.value})}
              className="px-2 py-1.5 border border-gray-300 rounded-md focus:ring-2 focus:ring-[#202654] focus:border-transparent text-sm"
            >
              <option value="">Tous statuts</option>
              <option value="absent">Absent</option>
              <option value="present">Présent</option>
            </select>

            {/* Filtre par date */}
            <input
              type="date"
              value={searchFilters.dateDebut}
              onChange={(e) => setSearchFilters({...searchFilters, dateDebut: e.target.value})}
              className="px-2 py-1.5 border border-gray-300 rounded-md focus:ring-2 focus:ring-[#202654] focus:border-transparent text-sm"
            />

            {/* Bouton de réinitialisation */}
            <button
              onClick={handleClearSearch}
              className="px-3 py-1.5 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 transition-colors"
            >
              Réinitialiser
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default PonctualiteSearchBar; 